import { Component, inject, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { CachedValuesService } from '@services/cached-values';
import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { TranslateService } from '@ngx-translate/core';
import { AgreementInventoryForm } from '../../shared-agreement.model';

@UntilDestroy()
@Component({
    selector: 'app-agreement-inventory',
    templateUrl: './inventory.component.html',
    styleUrl: './inventory.component.scss'
})
export class AgreementInventoryComponent {
    @Input() public inventoryForm: FormGroup<AgreementInventoryForm>;
    @Input() public showPotentialValidationMessages: boolean;
    private readonly cachedValuesService = inject(CachedValuesService);
    private readonly translateService = inject(TranslateService);

    public get f() {
        return this.inventoryForm.controls;
    }

    public modelYears: DropdownItem<number>[] = this.cachedValuesService.generateNumericDropdownItems(
        this.currentYearPlusOne,
        2000
    );

    public get currentYearPlusOne(): number {
        const currentYear = new Date().getFullYear();
        return currentYear + 1;
    }
}
